import {
  type Language,
  RTL_LANGUAGES,
  supportedLanguages,
} from './i18n-config';

type LocaleForLanguage = {
  [key in Language]: string[];
};

const supportedLocalesForLanguage: LocaleForLanguage = {
  de: ['de-DE'],
  en: ['en-GB'],
  ar: ['ar-AR'],
  fr: ['fr-FR'],
};

export function getLocale(language: Language): string {
  const locales = supportedLocalesForLanguage[language];

  if (!locales || locales.length === 0) {
    console.warn(`No locale found for language: ${language}`);

    return `${language}-${language.toUpperCase()}`;
  }

  return locales[0];
}

export function getCurrentLocale(i18nInstance: any): string {
  const currentLanguage =
    i18nInstance.resolvedLanguage || i18nInstance.language;

  return getLocale(currentLanguage as Language);
}

export function getAllSupportedLocales(): string[] {
  return Object.values(supportedLocalesForLanguage).flat();
}

export function isLocaleSupported(locale: string): boolean {
  return getAllSupportedLocales().includes(locale);
}

export function getLanguageFromLocale(locale: string): Language | null {
  const language = locale.split('-')[0] as Language;

  return supportedLocalesForLanguage[language] ? language : null;
}

export function isSupportedLanguage(lang?: string): lang is Language {
  return lang !== undefined && supportedLanguages.includes(lang as Language);
}

export const languageTitleByCode: Record<Language, string> = {
  de: 'Deutsch',
  en: 'English',
  ar: 'Arabic',
  fr: 'Français',
};

export const defaultLocale = getLocale(
  (process.env.NEXT_PUBLIC_DEFAULT_LANGUAGE as Language) || 'en',
);

export const isRtlLanguageFromLocale = (locale: string): boolean => {
  const language = getLanguageFromLocale(locale);

  return language ? RTL_LANGUAGES.includes(language) : false;
};
